import React, { useEffect, useRef, useState } from 'react';
import TelaDaExecucao from './TelaDaExecucao';
import { planConfigs } from '../../config/planConfigs';
import { Link, useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Palco.css';

const PASSOS = [
  { tela: 'escopo', chave: 'escopo', itens: ['escopoDominio', 'escopoCaminho', 'escopoSubdominios'] },
  { tela: 'rastreando', chave: 'rastreador', itens: [] },
  { tela: 'pronta', chave: 'fotografia', itens: ['fotografiaCota', 'fotografiaRepetir', 'fotografiaHistorico'] }
];

/**
 * A abertura: a folha com o título à esquerda e, à direita, a tela de uma
 * execução que fica parada enquanto a coluna de leitura passa. Cada passo de
 * "Do endereço à nota" troca o estado da tela quando chega ao meio da janela.
 */
const Palco = () => {
  const { t } = useIdioma();
  const { numero } = useFormato();
  const raiz = useRef(null);
  const [estado, setEstado] = useState('pronta');

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const observador = new IntersectionObserver(
      (itens) => {
        for (const item of itens) if (item.isIntersecting) setEstado(item.target.dataset.tela);
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );
    raiz.current.querySelectorAll('[data-tela]').forEach((el) => observador.observe(el));
    return () => observador.disconnect();
  }, []);

  const retencao = (plano) => planConfigs[plano].features.data_retention_days;

  return (
    <div className="palco" ref={raiz}>
      <div className="palco-leitura">
        <div className="palco-folha" data-tela="pronta">
          <h1>{t('inicio.palco.titulo')}</h1>
          <p className="palco-chamada">{t('inicio.palco.chamada')}</p>
          <Link to="/signup" className="sp-btn sp-btn-on-section nh-btn palco-acao">
            {t('inicio.palco.acao')} <span className="nh-seta" aria-hidden="true">→</span>
          </Link>
          <p className="palco-nota">
            {t('inicio.palco.nota', { paginas: numero(planConfigs.Basic.limits.pages) })}
          </p>
        </div>

        <section className="palco-como" id="como" aria-labelledby="como-titulo">
          <h2 id="como-titulo" data-r>{t('inicio.como.titulo')}</h2>
          <p className="palco-intro" data-r style={{ '--i': 1 }}>{t('inicio.como.intro')}</p>

          {PASSOS.map((p) => (
            <article className="palco-passo" data-tela={p.tela} key={p.tela}>
              <h3 data-r>{t(`inicio.como.${p.chave}Titulo`)}</h3>
              <p data-r style={{ '--i': 1 }}>{t(`inicio.como.${p.chave}Texto`)}</p>
              {p.itens.length > 0 && (
                <ul className="nh-lista" data-r style={{ '--i': 2 }}>
                  {p.itens.map((item) => (
                    <li key={item}>
                      {t(`inicio.como.${item}`, { min: retencao('Basic'), max: retencao('Pro') })}
                    </li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </section>
      </div>

      <div className="palco-tela">
        <TelaDaExecucao estado={estado} />
      </div>
    </div>
  );
};

export default Palco;
